import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { path } from "../../path";
import { useSelector } from "react-redux";

const UrlRedirectPage = () => {
  const { identifier, shortCode } = useParams();
  const { user } = useSelector(state => state.AuthReducer)

  useEffect(() => {
    const fetchRedirect = async () => {
      try {
        const res = await axios.get(
          `${path}/shorten/${identifier}/${shortCode}`
        );
        window.location.href = res.data.originalUrl;
      } catch (err) {
        console.error("Invalid or expired link");
      }
    };

    fetchRedirect();
  }, [identifier, shortCode]);

  return (
    <div className="h-dvh flex items-center justify-center gap-2">
        <div className="w-5 h-5 rounded-full border-2 border-[#707C97] border-t-[#F6F5FA] animate-spin" />
        <p className="text-lg" style={{ color: user?.theme === "dark"? "#fff": "#000" }}>Redirecting you to the original page...</p>
    </div>
  );
};

export default UrlRedirectPage;